import type { FaireProductEntity } from "../../entity_types/product";

export const p_5papqarjrj: FaireProductEntity = {
  token: "p_5papqarjrj",
  type: "product",
  name: "Solid Color Wool Knit Triangle Scarf",
  brandToken: "b_j2hghp5gvd",
  brandName: "Mirazshoes WholeSale",
  imageUrl:
    "https://cdn.faire.com/fastly/0b87d83706989fe71632e212e73b01ec39c9be1b4b1f90d0abec0c493411275f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/42a3c9cc3ce675918b31e1647a53fc47c24e15dc4da02a2775394c707d5dde63.jpeg",
    "https://cdn.faire.com/fastly/51cb698076172b138a8f89aa3f4297680ea715b7e3e5db9e170b43f0ccfc05af.jpeg",
    "https://cdn.faire.com/fastly/5e14baae0c437b71d07c69a13d9cd94746d373c7962054adbd929a4c735ad78e.jpeg",
    "https://cdn.faire.com/fastly/a3235bca582e9f4254664944663c81b5b07f4de46a3f7d63ac271d49d72eb3fb.jpeg",
    "https://cdn.faire.com/fastly/93189f85796e88f983fc11d5febb8274cd3da49a76ce0f05922cb282e805e147.jpeg",
  ],
  priceDollars: 10.49,
  description:
    "Material:Wool Blend\n\nStyle:Cute,Intellectual,All-match,Look-younger\n\nOccasion:Business,Gift,Going out,Artistic Retro,Girlish Sweetness,Light Maturity,Stylish Selection,Leisure Fashion\n\nSeasons:Spring,Autumn,Winter\n",
  tags: [],
  msrpDollars: 20.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:52.513Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
